import { render } from "./CruiseTypeChoose.vue?vue&type=template&id=378a12a0"
import script from "./CruiseTypeChoose.vue?vue&type=script&lang=js"
export * from "./CruiseTypeChoose.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__